import { render, staticRenderFns } from "./DeleteData.vue?vue&type=template&id=45642a9e&scoped=true"
import script from "./DeleteData.vue?vue&type=script&lang=js"
export * from "./DeleteData.vue?vue&type=script&lang=js"
import style0 from "./DeleteData.vue?vue&type=style&index=0&id=45642a9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45642a9e",
  null
  
)

export default component.exports